export default __webpack_public_path__ + "2e93de450a8c6391aa8efbc536d46849.svg";